import React, { Component } from "react";
import { connect } from "react-redux";
import DupontIconButton from "components/DupontIconButton";
import DeleteTableIcon from "assets/SvgIcon/Table/DeleteTableIcon";
import { valueStrings } from "constants/constantStrings";

class SystemDeleteRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }

  invokeParentMethod() {
    this.props.context.handleTrashClick(this.props.node.data);
  }

  render() {
    return (
      this.props.idToken.sub !== this.props.data.UserID && (
        <DupontIconButton tooltip={valueStrings.delete} onClick={this.invokeParentMethod}>
          <DeleteTableIcon />
        </DupontIconButton>
      )
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    idToken: auth.idToken
  };
};

export default connect(mapStateToProps)(SystemDeleteRenderer);
